module.exports = __webpack_public_path__ + "img/img49.f024c89a.png";